export const DEV_CLIENT_URL =
    'https://www.labanquepostale.fr/particulier/connexion-espace-client.html';
export const STAGING_CLIENT_URL =
    'https://www.labanquepostale.fr/particulier/connexion-espace-client.html';
export const PROD_CLIENT_URL =
    'https://www.labanquepostale.fr/particulier/connexion-espace-client.html';



// WEBPACK FOOTER //
// ./src/constants/sso.js